export const form = {
  formCopyLink: 'Kopijuoti nuorodą',
  formLinkCopied: 'Nuoroda nukopijuota!'
}
